import store from './store'
import update from './update'
import relateMedia from './relateMedia'
import relateGroups from './relateGroups'
import relateMembers from './relateMembers'

const namespaced = true

export default {
  namespaced,
  modules: {
    store,
    update,
    relateMedia,
    relateGroups,
    relateMembers
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/modules/forms/index.js